module.exports = __webpack_public_path__ + "img/right-lamp.43f0652f.png";